import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot'; // 🛠️ Corregido typo "Layuot"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// --- CONFIGURACIÓN DE ESTILOS ---
const THEME = {
    primary: '#1F2937',
    secondary: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    bg: '#F3F4F6',
    white: '#FFFFFF',
    border: '#E5E7EB'
};

function AdminDashboard() {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            const token = localStorage.getItem('token');
            try {
                // El backend ya nos devuelve la suma total (Grano + Molido) en los KPIs
                const { data } = await api.get('/pedidos/admin/global-stats', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStats(data);
            } catch (error) {
                console.error("Error cargando dashboard:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    // Componentes de Estilo para las Tarjetas
    const StatCard = ({ title, value, sub, color, icon, onClick }) => (
        <div 
            onClick={onClick}
            style={{ 
                background: 'white', padding: 25, borderRadius: 12, 
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)', 
                borderLeft: `5px solid ${color}`,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'transform 0.2s'
            }}
            onMouseOver={e => onClick && (e.currentTarget.style.transform = 'translateY(-3px)')}
            onMouseOut={e => onClick && (e.currentTarget.style.transform = 'translateY(0)')}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <div style={{ fontSize: 13, color: '#6B7280', fontWeight: 'bold', textTransform: 'uppercase' }}>{title}</div>
                    <div style={{ fontSize: 32, fontWeight: '900', color: '#111827', marginTop: 5 }}>{value}</div>
                    {sub && <div style={{ fontSize: 13, color: color, marginTop: 5, fontWeight: '500' }}>{sub}</div>}
                </div>
                <div style={{ fontSize: 24, background: `${color}20`, padding: 10, borderRadius: 10 }}>{icon}</div>
            </div>
        </div>
    );

    if (loading) return <AdminLayout title="Panel de Control"><div style={{textAlign:'center', marginTop:50}}>Cargando métricas...</div></AdminLayout>;

    return (
        <AdminLayout title="Panel de Control">
            
            {/* 1. TARJETAS SUPERIORES (KPIs) */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 20, marginBottom: 30 }}>
                
                {/* ACCESO A TU BODEGA (Producción) */}
                <StatCard 
                    title="🏭 Mi Bodega (Tueste)" 
                    value="Gestión" 
                    sub="Registrar Producción" 
                    color={THEME.primary} 
                    icon="⚙️"
                    onClick={() => navigate('/admin/almacen')} 
                />

                <StatCard 
                    title="Pedidos Pendientes" 
                    value={stats?.kpis.pendientes || 0} 
                    sub="Requieren Atención" 
                    color={THEME.warning} 
                    icon="🔔"
                    onClick={() => navigate('/admin/pedidos')}
                />

                <StatCard 
                    title="Ventas del Mes" 
                    value={`${stats?.kpis.kgVendidosMes || 0} Kg`} 
                    sub="Grano + Molido" 
                    color={THEME.success} 
                    icon="⚖️"
                    onClick={() => navigate('/admin/pagos')}
                />

                {/* ACCESO A INVENTARIO DE CLIENTES (Alertas) */}
                <StatCard 
                    title="Alertas de Stock" 
                    value={stats?.kpis.alertasStock || 0} 
                    sub="Sucursales con stock bajo" 
                    color={THEME.danger} 
                    icon="📉"
                    onClick={() => navigate('/admin/inventario')}
                />
            </div>

            {/* 2. GRÁFICA Y ACCIONES RÁPIDAS */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
                
                {/* Gráfica de Ventas */}
                <div style={{ background: 'white', padding: 25, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)', minHeight: 350 }}>
                    <h3 style={{ marginTop: 0, color: THEME.primary, marginBottom: 20 }}>Tendencia de Ventas (6 Meses)</h3>
                    <div style={{ height: 300, width: '100%' }}>
                        <ResponsiveContainer>
                            <LineChart data={stats?.chartData || []}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fill: '#6B7280', fontSize: 12}} dy={10} />
                                <YAxis axisLine={false} tickLine={false} tick={{fill: '#6B7280', fontSize: 12}} />
                                <Tooltip contentStyle={{ borderRadius: 8, border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                                <Line type="monotone" dataKey="kg" stroke={THEME.secondary} strokeWidth={3} dot={{r: 4, fill: THEME.secondary}} activeDot={{r: 6}} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                {/* Accesos Directos Laterales */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    <div style={{ background: THEME.secondary, color: 'white', padding: 25, borderRadius: 12, boxShadow: '0 10px 15px -3px rgba(59, 130, 246, 0.3)' }}>
                        <h3 style={{ margin: 0 }}>Nuevo Pedido</h3>
                        <p style={{ fontSize: 13, opacity: 0.9, marginTop: 5, marginBottom: 20 }}>Crear una solicitud manual para un cliente.</p>
                        <button 
                            onClick={() => navigate('/admin/solicitar-pedido')}
                            style={{ width: '100%', padding: 12, background: 'white', color: THEME.secondary, border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}
                        >
                            + Crear Pedido
                        </button>
                    </div>

                    <div style={{ background: 'white', padding: 25, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                        <h3 style={{ marginTop: 0, fontSize: 16 }}>Directorio Rápido</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            <button onClick={() => navigate('/admin/clientes')} style={{ textAlign: 'left', padding: 10, background: '#F9FAFB', border: 'none', borderRadius: 6, cursor: 'pointer', color: '#4B5563', fontWeight: '500' }}>
                                👥 Gestionar Clientes
                            </button>
                            <button onClick={() => navigate('/admin/inventario')} style={{ textAlign: 'left', padding: 10, background: '#F9FAFB', border: 'none', borderRadius: 6, cursor: 'pointer', color: '#4B5563', fontWeight: '500' }}>
                                📦 Ver Inventario Global
                            </button>
                             <button onClick={() => navigate('/admin/almacen')} style={{ textAlign: 'left', padding: 10, background: '#F9FAFB', border: 'none', borderRadius: 6, cursor: 'pointer', color: '#4B5563', fontWeight: '500' }}>
                                🏭 Mi Bodega
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </AdminLayout>
    );
}

export default AdminDashboard;